import api from "../../../api/axios";

const getSites = async (serverUuid) => {
  try {
    const url = `/api/servers/${serverUuid}/sites`;

    const { data } = await api.get(url);

    return { success: true, data };
  } catch (error) {
    console.error("getServers response", error);
    return { success: false, loggedOut: error.response.status === 403 };
  }
};

/**
 *
 * @param {UUID} siteId
 * @param {{cozifyKey: string, cozifySecret: string}} body
 * @returns
 */
const updateSite = async (serverUuid, siteId, body) => {
  try {
    const url = `/api/servers/${serverUuid}/sites/${siteId}`;

    await api.put(url, body);

    return { success: true };
  } catch (error) {
    console.error("getServers response", error);
    return { success: false, loggedOut: error.response.status === 403 };
  }
};

export default { getSites, updateSite };
